<template>
  <div>
    <el-input
      v-model="inputValue"
      :rows="rows"
      :placeholder="placeholder"
      style="margin-bottom: 10px"
      @change="handleValueChanged"
      type="textarea"
    ></el-input>
    <el-upload
      action
      name="upload"
      :disabled="disabled"
      :before-upload="handleBeforeUpload"
      :show-file-list="false"
    >
      <el-button type="primary" :disabled="disabled" :loading="loading">
        {{ btnLabel }}
      </el-button>
    </el-upload>
  </div>
</template>

<style lang="less" scoped>
/deep/ .el-button.is-loading:before {
  background-color: transparent;
}
</style>

<script>
export default {
  data() {
    return {
      fileReader: new FileReader(),
      inputValue: "",
    };
  },
  model: {
    prop: "value",
    event: "change",
  },
  watch: {
    value() {
      this.initValue();
    }
  },
  props: {
    value: {
      type: String
    },
    types: {
      type: Array,
      default: () => {
        return [];
      },
    },
    placeholder: {
      type: String,
      default: "请输入文件Base64或上传文件"
    },
    fileSize: {
      type: Number | String,
      default: 1024,
    },
    rows: {
      type: Number,
      default: 5,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    btnLabel: {
      type: String,
      default: "上传文件",
    }
  },
  methods: {
    initValue() {
      this.inputValue = this.value;
    },
    sizeConver(limit) {
      var size = "";
      if (limit < 1 * 1024) {
        size = limit.toFixed(2) + "B";
      } else if (limit < 1 * 1024 * 1024) {
        size = (limit / 1024).toFixed(2) + "KB";
      } else if (limit < 1 * 1024 * 1024 * 1024) {
        size = (limit / (1024 * 1024)).toFixed(2) + "MB";
      } else {
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
      }
      var sizestr = size + "";
      var len = sizestr.indexOf(".");
      var dec = sizestr.substr(len + 1, 2);
      if (dec == "00") {
        return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
      }
      return sizestr;
    },
    checkFileSize(e) {
      return e.size / 1024 / 1024 < this.fileSize / 1024;
    },
    checkFileType(e) {
      if (this.types && this.types.length > 0) {
        try {
          return this.types.indexOf(e.type) >= 0;
        } catch (error) {
        }
        return false;
      }
      return true;
    },
    handleValueChanged() {
      this.$emit('change', this.inputValue);
    },
    handleBeforeUpload(e, l) {
      if (!this.checkFileType(e)) {
        this.error("文件格式错误");
        return false;
      }
      if (!this.checkFileSize(e)) {
        this.error(`文件大小不能超过${this.sizeConver(this.fileSize * 1024)}`);
        return false;
      }
      this.fileReader.readAsDataURL(e);
      this.fileReader.onload = () => {
        let base64Str = this.fileReader.result;
        this.$emit('change', base64Str.split(",")[1]);
      }
      return false;
    },
  },
  mounted() {
    this.initValue();
  }
};
</script>
